<template>
  <div class="main dl_gray_color_bg">
    <mt-header :title="$t('设置PIN码')" class="dl_header_white dl_line_bottom" fixed>
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>

    <div class="container">
      <div class="swiper">
        <p>{{$t('为了保护您的资产安全，请先设置PIN码，PIN码会用于解锁钱包和发币。')}}</p>
        <p>{{$t('PIN码为本地密码，请妥善保存，如果丢失，无法恢复')}}</p>
      </div>
      <div class="passContainer">
        <Password ref="pay_pass" v-on:end="onEnd"></Password>
      </div>
      <div class="close_pin"  @click="close_pin">
        {{$t('关闭PIN码')}}
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import {closePin} from '@/utils/index'
import Password from "@/components/Password";
import md5 from "js-md5"
export default {
  name: "PinSet",
  components: { Toast, Password },
  data() {
    return {};
  },
  activated:function(){
    this.$refs.pay_pass.focus();
    this.$refs.pay_pass.reset();
  },       
  methods: {
    goback: function() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    onEnd: function(val) {
      this.$store.dispatch("setPin", md5(val));
      this.$router.push("/index/mypage");
      Toast(this.$t("设置成功"));
    },
    close_pin: function(val) {
      this.$store.dispatch("setPin", '');
      this.$router.push("/index/mypage");
      closePin();
    },
  
  },
  mounted() {}
};
</script>

<style scoped>
.main {
  padding-top: 40px;
  height: 100%;
  box-sizing: border-box;
}
.container {
  padding: 50px 10px 10px 10px;
}
.swiper {
  background-color: #4a4a4a;
  box-sizing: border-box;
  border-radius: 10px;
  color: #fff;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 20px;
}
.swiper p {
  font-size: 12px;
  margin: 5px;
}
.passContainer{
  margin-top: 50px
}
.close_pin{
    text-align: center;
    color: #26a2ff;
    margin: 10px 0;
    font-size: 14px;
}
</style>

